var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HeadingCmp"},[_c(_vm.dataTag,{tag:"component",staticClass:"heading-tag"},[_vm._t("default")],2),(_vm.hasSubtitle)?_c('div',{staticClass:"subtitle mt-2 mt-lg-3"},[_vm._t("subtitle")],2):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }